import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import useWebPost from "../../utils/useWebPost";
import ImgUploader from "../../components/ImgUploader";
import { Button, Table, Form, Input, message } from "antd";
import renderFileList from "../../components/renderFileList";
import { checkp } from "../../utils/functions";
import CustModal from "../../components/ShowModal";

function TszList() {
    const { type } = useParams();
    const webPost = useWebPost();
    const [data, setData] = useState(null);
    const [isloading, setLoading] = useState(true);
    const [currentItem, setCurrentItem] = useState(null);
    const [form] = Form.useForm();
    const loadingRef = useRef(null);
    useEffect(() => {
        async function getfs() {
            const res = await webPost('getTsz', { type });
            if (res) {
                setData(res);
            }
            setLoading(false);
        }
        getfs();
    }, [type])
    const columns = [
        { title: '附件', dataIndex: 'fs', render: (_) => renderFileList(_) },
        { title: '说明', dataIndex: 'ps' },
        checkp('tszm') && {
            title: '操作', dataIndex: 'ts', render: (_, rs) => {
                return <Button onClick={ ()=> modData(rs)}>修改</Button>
            }
        }
    ].filter(Boolean);
    const modData = (rs) => {
        setCurrentItem(rs);
        form.setFieldsValue(rs)
    }
    const saveSubmit = async ()=>{
        if(loadingRef.current)return;
        loadingRef.current=true;
        try {
            const values = await form.validateFields();
            const res = await webPost("saveTzs",{...values, type});
            if(res){
                const ds = data.map((prev)=>({...prev, fs:values.fs, ps:values.ps}));
                setData(ds);
                closeModal();
            }
        } catch (error) {
            message.error("保存失败"+error);
        }finally{
            loadingRef.current = false;
        }
    }
    const closeModal = ()=>{
        setCurrentItem(null)
    }
    return <>
        <Table dataSource={data} columns={columns} pagination={false} rowKey={(_)=>`${type}_${Math.random().toString(36)}`} loading={isloading} />
        <CustModal open={currentItem !== null} onOk={saveSubmit} onCancel={closeModal} >
            <Form form={form} layout="vertical">
                <Form.Item label="附件" name="fs"><ImgUploader /></Form.Item>
                <Form.Item label="说明" name="ps"><Input.TextArea cols={3} /></Form.Item>
            </Form>
        </CustModal>
    </>
}
export default TszList;